import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmojiOrangeSmile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23.9984 48C37.2534 48 47.9969 37.2565 47.9969 24.0016C47.9969 10.7466 37.2534 0 23.9984 0C10.7435 0 0 10.7435 0 23.9984C0 37.2534 10.7435 47.9969 23.9984 47.9969",
			fill: "#FF5C00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.9332 30.6552C25.0804 30.6741 26.234 31.4284 26.2591 32.6637C26.2843 33.8959 25.0396 34.6534 23.9332 34.6722C22.7859 34.6911 21.6323 33.8707 21.6072 32.6637C21.582 31.4316 22.8268 30.6741 23.9332 30.6552C24.8918 30.6395 24.895 29.1496 23.9332 29.1653C21.9624 29.1968 20.1582 30.6049 20.1173 32.6637C20.0733 34.7225 22.0315 36.1307 23.9332 36.1621C25.904 36.1936 27.7082 34.6722 27.749 32.6637C27.793 30.6049 25.838 29.1968 23.9332 29.1653C22.9713 29.1496 22.9745 30.6395 23.9332 30.6552Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2702 22.3983C14.2702 25.0386 12.1297 27.176 9.49253 27.176C6.85537 27.176 4.71484 25.0354 4.71484 22.3983C4.71484 19.7611 6.85537 17.6206 9.49253 17.6206C12.1297 17.6206 14.2702 19.7611 14.2702 22.3983Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9195 20.8616C10.9195 21.6379 10.2909 22.2666 9.51451 22.2666C8.73814 22.2666 8.1095 21.6379 8.1095 20.8616C8.1095 20.0852 8.73814 19.4565 9.51451 19.4565C10.2909 19.4565 10.9195 20.0852 10.9195 20.8616Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.2883 22.3983C43.2883 25.0386 41.1477 27.176 38.5106 27.176C35.8734 27.176 33.7329 25.0354 33.7329 22.3983C33.7329 19.7611 35.8734 17.6206 38.5106 17.6206C41.1477 17.6206 43.2883 19.7611 43.2883 22.3983Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.9408 20.8616C39.9408 21.6379 39.3121 22.2666 38.5358 22.2666C37.7594 22.2666 37.1307 21.6379 37.1307 20.8616C37.1307 20.0852 37.7594 19.4565 38.5358 19.4565C39.3121 19.4565 39.9408 20.0852 39.9408 20.8616Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9217 31.2497C12.9217 32.5919 11.457 33.6826 9.64965 33.6826C7.8423 33.6826 6.37756 32.595 6.37756 31.2497C6.37756 29.9044 7.8423 28.8169 9.64965 28.8169C11.457 28.8169 12.9217 29.9044 12.9217 31.2497Z",
			fill: "#FFD525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.6224 31.2497C41.6224 32.5919 40.1577 33.6826 38.3503 33.6826C36.543 33.6826 35.0782 32.595 35.0782 31.2497C35.0782 29.9044 36.543 28.8169 38.3503 28.8169C40.1577 28.8169 41.6224 29.9044 41.6224 31.2497Z",
			fill: "#FFD525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.65809 16.6424C7.71122 16.263 10.7613 15.8827 13.8153 15.5003C14.2194 15.4491 14.5585 15.1918 14.5568 14.7488C14.5554 14.3774 14.2087 13.9591 13.8053 14.0072C10.7522 14.3866 7.70126 14.7699 4.64813 15.1493C4.24394 15.2005 3.90489 15.4578 3.90659 15.9008C3.90797 16.2722 4.25471 16.6905 4.65809 16.6424Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.352 15.1525C40.2989 14.773 37.2488 14.3928 34.1979 14.0095C33.7937 13.9584 33.4508 14.3789 33.4464 14.7511C33.4447 15.1941 33.7837 15.4514 34.1879 15.5026L43.3421 16.6455C43.7463 16.6967 44.0891 16.2761 44.0936 15.904C44.0953 15.461 43.7562 15.2036 43.352 15.1525Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 48C37.2546 48 48 37.2546 48 24C48 10.7454 37.2546 0 24 0C10.7454 0 0 10.7454 0 24C0 37.2546 10.7454 48 24 48Z",
			fill: "#FF5C00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2669 19.8895C14.2669 22.5275 12.1289 24.6686 9.48776 24.6686C6.84666 24.6686 4.70862 22.5306 4.70862 19.8895C4.70862 17.2484 6.84972 15.1104 9.48776 15.1104C12.1258 15.1104 14.2669 17.2515 14.2669 19.8895Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.34973 18.0397C9.34973 18.8157 8.7209 19.4446 7.94482 19.4446C7.16875 19.4446 6.53992 18.8157 6.53992 18.0397C6.53992 17.2636 7.16875 16.6348 7.94482 16.6348C8.7209 16.6348 9.34973 17.2636 9.34973 18.0397Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8895 20.2546C10.8895 20.7025 10.5276 21.0645 10.0797 21.0645C9.63186 21.0645 9.2699 20.7025 9.2699 20.2546C9.2699 19.8068 9.63186 19.4448 10.0797 19.4448C10.5276 19.4448 10.8895 19.8068 10.8895 20.2546Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.2884 19.8895C43.2884 22.5275 41.1473 24.6686 38.5092 24.6686C35.8712 24.6686 33.7301 22.5306 33.7301 19.8895C33.7301 17.2484 35.8712 15.1104 38.5092 15.1104C41.1473 15.1104 43.2884 17.2515 43.2884 19.8895Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.3682 18.0397C38.3682 18.8157 37.7393 19.4446 36.9633 19.4446C36.1872 19.4446 35.5583 18.8157 35.5583 18.0397C35.5583 17.2636 36.1872 16.6348 36.9633 16.6348C37.7393 16.6348 38.3682 17.2636 38.3682 18.0397Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.908 20.2546C39.908 20.7025 39.546 21.0645 39.0981 21.0645C38.6503 21.0645 38.2883 20.7025 38.2883 20.2546C38.2883 19.8068 38.6503 19.4448 39.0981 19.4448C39.546 19.4448 39.908 19.8068 39.908 20.2546Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.6196 27.2885C28.8313 29.6842 26.5951 31.3314 24.0797 31.3958C21.5705 31.4603 19.227 29.8406 18.3711 27.4879C18.2331 27.1075 17.8711 26.8529 17.454 26.9664C17.0859 27.0676 16.7945 27.5001 16.9325 27.8836C18.0276 30.8928 20.8619 32.9142 24.0767 32.8866C27.2668 32.859 30.0705 30.6811 31.0552 27.6842C31.3558 26.767 29.9172 26.3774 29.6165 27.2885",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9203 28.7421C12.9203 30.0856 11.4571 31.1746 9.65033 31.1746C7.84358 31.1746 6.37732 30.0856 6.37732 28.7421C6.37732 27.3985 7.84358 26.3096 9.65033 26.3096C11.4571 26.3096 12.9203 27.3985 12.9203 28.7421Z",
			fill: "#FFD525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.6196 28.7421C41.6196 30.0856 40.1564 31.1746 38.3497 31.1746C36.5429 31.1746 35.0767 30.0856 35.0767 28.7421C35.0767 27.3985 36.5429 26.3096 38.3497 26.3096C40.1564 26.3096 41.6196 27.3985 41.6196 28.7421Z",
			fill: "#FFD525"
		})
	]
});
export default SvgEmojiOrangeSmile;
